import PropTypes from "prop-types";
import React from "react";
import Dropdown from '../formsUi/dropdown/DropDown';
import Label from '../formsUi/common/label/Label';
import ValidationMessage from '../formsUi/common/validation/ValidationMessage';

const FormDropdownControls = ({
    keyId,
    dataField,
    labelName,
    name,
    type,
    value,
    error,
    formSetting,
    formData,
    overRideProps,
    isRequired,
    fieldSetting,
    onChange,
    onValidation,
    onBlur,
    onActionChange,
    ...otherProps
}) => {

    const handleChange = (selectedOption) => {
        if (onChange) {
            if (fieldSetting?.isMultiSelect) {
                const selectedValues = selectedOption.map((option) => option.value);
                onChange(dataField, selectedValues);
            } else {
                onChange(dataField, selectedOption);
            }
        }
    };

    const handleOnBlur = () => {
        if (onValidation) {
            onValidation(dataField);
        }
    };

    return (
        <div className="dropdown-label">
            <div className="input-label-part">
                {labelName && labelName !== "" && (
                    <Label labelName={labelName} isRequired={isRequired} />
                )}
                {fieldSetting?.subTitle ? (
                    <div className="section-title">
                        <h5>{fieldSetting.subTitle}</h5>
                    </div>
                ) : ("")}
                <span className="dropdown-with-btn">
                    <Dropdown
                        isInputField
                        placeholder={fieldSetting.placeholder}
                        onChange={handleChange}
                        onBlur={handleOnBlur}
                        options={fieldSetting?.options}
                        value={value}
                        isMultiSelect={fieldSetting?.isMultiSelect}
                        isGrouped={fieldSetting?.isGrouped ?? false}
                        isAlphabeticallyGrouped={fieldSetting?.isAlphabeticallyGrouped ?? false}
                        isClearable={fieldSetting?.isClearable ?? true}
                        isDisabled={formSetting?.isViewOnly ||
                            (overRideProps?.isDisable !== false && fieldSetting?.isDisable) ||
                            false}
                        isSearchable={fieldSetting?.isSearchable}
                        maxMenuHeight={fieldSetting?.maxMenuHeight}
                        isLoading={overRideProps?.isLoading || fieldSetting?.isLoading || otherProps.isLoading}
                        {...otherProps} />
                </span>
            </div>
            <ValidationMessage error={error || ""}
                helperText={fieldSetting?.helperText}
                successText={overRideProps?.successText ?? fieldSetting?.successText} />
        </div>
    );
};

FormDropdownControls.propTypes = {
    keyId: PropTypes.string.isRequired,
    dataField: PropTypes.string.isRequired,
    labelName: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    error: PropTypes.string,
    formSetting: PropTypes.shape({
        isViewOnly: PropTypes.bool
    }),
    fieldSetting: PropTypes.shape({
        subTitle: PropTypes.string,
        placeholder: PropTypes.string,
        options: PropTypes.arrayOf(PropTypes.object),
        isFormControl: PropTypes.bool,
        isMultiSelect: PropTypes.bool,
        isGrouped: PropTypes.bool,
        isAlphabeticallyGrouped: PropTypes.bool,
        isSearchable: PropTypes.bool,
        isDisable: PropTypes.bool,
        isLoading: PropTypes.bool,
        maxMenuHeight: PropTypes.number,
        formControltemplate: PropTypes.any
    }),
    formData: PropTypes.object,
    overRideProps: PropTypes.shape({
        isDisable: PropTypes.bool,
        isLoading: PropTypes.bool,
    }),
    isRequired: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    onValidation: PropTypes.func,
    onBlur: PropTypes.func,
    onActionChange: PropTypes.func,
};

export default FormDropdownControls;